import React from 'react';
import { Alert, Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  DashboardHero,
  DashboardFilters,
  HistorySection,
  PipelineSection,
  DetailedTableSection,
  buildStageMeta,
} from '../components/early-accumulation/EarlyAccumulationSections';
import { DetailDrawer } from '../components/early-accumulation/EarlyAccumulationDrawer';
import { useEarlyAccumulationDashboard } from '../components/early-accumulation/useEarlyAccumulationDashboard';

function EarlyAccumulationDashboardScreen() {
  const { t, i18n } = useTranslation();
  const {
    locale,
    loading,
    calculating,
    error,
    data,
    history,
    historyLoading,
    selectedRow,
    setSelectedRow,
    filters,
    setFilters,
    showAdvanced,
    setShowAdvanced,
    showHistory,
    setShowHistory,
    load,
    handleCalculate,
    candidates,
    scanDateValue,
    pipeline,
    promotions,
    marketRegime,
  } = useEarlyAccumulationDashboard({ t, language: i18n.language });

  const stageMeta = buildStageMeta(t);

  return (
    <Box sx={{ p: 2.5, maxWidth: 1600, mx: 'auto', minHeight: '100%' }}>
      <Stack spacing={2}>
        <DashboardHero
          data={data}
          scanDateValue={scanDateValue}
          marketRegime={marketRegime}
          calculating={calculating}
          loading={loading}
          onCalculate={handleCalculate}
          t={t}
        />

        {error && <Alert severity="error" sx={{ borderRadius: 2 }}>{error}</Alert>}

        <DashboardFilters
          filters={filters}
          setFilters={setFilters}
          loading={loading}
          showHistory={showHistory}
          setShowHistory={setShowHistory}
          showAdvanced={showAdvanced}
          setShowAdvanced={setShowAdvanced}
          onApply={load}
          t={t}
        />

        <PipelineSection
          promotions={promotions}
          stageMetaMap={stageMeta}
          pipeline={pipeline}
          loading={loading}
          hasData={Boolean(data)}
          onSelectRow={setSelectedRow}
          language={i18n.language}
          locale={locale}
          t={t}
        />

        {showAdvanced && (
          <DetailedTableSection
            candidates={candidates}
            loading={loading}
            stageMetaMap={stageMeta}
            locale={locale}
            language={i18n.language}
            onSelectRow={setSelectedRow}
            t={t}
          />
        )}

        {showHistory && (
          <HistorySection
            history={history}
            historyLoading={historyLoading}
            locale={locale}
            t={t}
          />
        )}

        <DetailDrawer
          row={selectedRow}
          open={Boolean(selectedRow)}
          onClose={() => setSelectedRow(null)}
          t={t}
          locale={locale}
          lang={i18n.language}
        />
      </Stack>
    </Box>
  );
}

export default function EarlyAccumulationDashboard() {
  return <EarlyAccumulationDashboardScreen />;
}
